import * as z from "zod";

export const upsertStayAiIntegration = {
  name: "upsertStayAiIntegration" as const,
  input: z.object({ apiKey: z.string() }),
  output: z.object({ success: z.boolean() }),
};
